// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-chat-mdx": () => import("./../../../src/pages/chat.mdx" /* webpackChunkName: "component---src-pages-chat-mdx" */),
  "component---src-pages-events-mdx": () => import("./../../../src/pages/events.mdx" /* webpackChunkName: "component---src-pages-events-mdx" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-orchestrator-mdx": () => import("./../../../src/pages/orchestrator.mdx" /* webpackChunkName: "component---src-pages-orchestrator-mdx" */)
}

